<div class="modal-header">
  <h3 class="modal-title">Existing Batch Transactions</h3>
  <div class="header-actions">
    <i class="fa"
      [ngClass]="{'fa-plus-square-o': minimised, 'fa-minus-square-o': !minimised}"
      style="margin-right: 10px; cursor: pointer;"
    (click)="minimised = !minimised"></i>
    <i (click)="close()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

@if (!minimised) {
  <div class="modal-body">
    <div class="container-fluid">
      <!-- Tax Year / Status Row -->
      <div class="row filter-row">
        <div class="filter-group">
          <div>
            <label>Tax Year:</label>
            <select class="status-select year-select"
              [(ngModel)]="selectedYear.value">
              @for (yr of taxYears; track yr) {
                <option [value]="yr.value">{{ yr.label }}</option>
              }
            </select>
          </div>
          <div style="margin-left: 30px;">
            <label>Process Status:</label>
            <div>
              <select class="status-select"
                [(ngModel)]="selectedType"
                [disabled]="selectBox"
                (change)="typeSelection()">
                <option [ngValue]="null" disabled>Select status</option>
                @for (t of types; track t) {
                  <option [ngValue]="t">{{ t.name }}</option>
                }
              </select>
              <button type="button" class="btn btn-primary loadTranBtn"
                (click)="loadProcess()"
              [disabled]="dropdownBtn">Load</button>
              @if (showClearBtn) {
                <button type="button"
                  class="btn btn-danger fa fa-times deleteTranBtn"
                (click)="clearTransView()"></button>
              }
            </div>
          </div>
        </div>
        <!-- Filters Row (shown after data loads) -->
        @if (gridFiltersData) {
          <div class="filter-group search-group">
            <div>
              <label>User:</label>
              <input type="text" class="search-input"
                placeholder="first or last name"
                [(ngModel)]="filter.user"
                (ngModelChange)="filterBatchList()">
              </div>
              <div style="margin-left: 30px;">
                <label>Transaction Number:</label>
                <input type="text" class="search-input"
                  placeholder="transaction number"
                  [(ngModel)]="filter.obj.TRANSACTION_ID"
                  (ngModelChange)="filterBatchList()">
                </div>
                <div style="margin-left: 30px;">
                  <label>Tag Version:</label>
                  <input type="text" class="search-input"
                    placeholder="enter tag number"
                    [(ngModel)]="filter.obj.IMPORT_TAG"
                    (ngModelChange)="filterBatchList()">
                  </div>
                </div>
              }
            </div>
            <!-- Search Row -->
            @if (gridFiltersData) {
              <div class="row search-row">
                <div class="search-bar">
                  <i class="fa fa-info-circle" title="Enter any keywords from uploaded batch data for content search"></i>
                  <div class="search-box">
                    <input type="text" class="content-search"
                      [(ngModel)]="searchEntity"
                      placeholder="Batch Content Search">
                    </div>
                    <button type="button" class="btn btn-success fa fa-search search-icon-btn"
                      (click)="searchEntityList()"
                    [disabled]="!searchEntity"></button>
                    <button type="button" class="btn btn-danger fa fa-times search-icon-btn"
                      (click)="clearEntityList()"
                    [disabled]="!searchEntity"></button>
                  </div>
                </div>
              }
            </div>
            <!-- Table Header -->
            <div class="container-fluid">
              <div class="row main-header">
                <div class="col-sm-2 text-center">Transaction No.</div>
                <div class="col-sm-2">User</div>
                <div class="col-sm-1">Tag No</div>
                <div class="col-sm-2">Scenario</div>
                <div class="col-sm-1">Date</div>
                <div class="col-sm-1 text-center">Records</div>
                <div class="col-sm-3 text-center">View Transactions</div>
              </div>
              <!-- Status Messages -->
              @if (dropdownSelectionMsg) {
                <div class="select-msg">
                  Please select process status to load the data
                </div>
              }
              @if (noDataFoundMsg) {
                <div class="noData-msg">
                  No transactions found for the selected status type.
                </div>
              }
              @if (noSearchDataFound) {
                <div class="noData-msg">
                  No results found, try with a different keyword.
                </div>
              }
              @if (showBatchLoader) {
                <div class="batch-loader">
                  <i class="fa fa-spinner fa-spin gt-refresh"></i>
                </div>
              }
              <!-- Transaction Rows -->
              <div class="main-body">
                @for (item of filteredBatchList; track item; let i = $index) {
                  <div class="main-body-data row">
                    <div class="col-sm-2 text-center">{{ item.TRANSACTION_ID }}</div>
                    <div class="col-sm-2">{{ item.USER_FIRST_NAME }} {{ item.USER_LAST_NAME }}</div>
                    <div class="col-sm-1 tag-col" [title]="item.IMPORT_TAG">
                      @if (item.IMPORT_TAG !== 'NA') {
                        <span>{{ item.IMPORT_TAG }}</span>
                      }
                    </div>
                    <div class="col-sm-2">{{ item.SCENARIO_DESC }}</div>
                    <div class="col-sm-1">{{ item.CREATED_ON }}</div>
                    <div class="col-sm-1 text-center">{{ item.RECORD_COUNT }}</div>
                    <div class="col-sm-3 text-center">
                      <button type="button" class="btn btn-primary view-trans-btn"
                        (click)="loadTransactions(i, item.TRANSACTION_ID, item.ENABLE_REPROCESS !== 0, item.IMPORT_TAG)"
                        [disabled]="item.show_transaction">
                        View Transactions
                      </button>
                      @if (item.show_transaction) {
                        <span>
                          <i class="fa fa-spinner fa-spin"></i>
                        </span>
                      }
                      @if (item.ENABLE_DELETE) {
                        <button type="button"
                          class="btn btn-danger fa fa-times deleteTranBtn"
                        (click)="requestDeleteTran(item.TRANSACTION_ID, i)"></button>
                      }
                      @if (item.delete_transaction) {
                        <span>
                          <i class="fa fa-spinner fa-spin"></i>
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        @if (!minimised) {
          <div class="modal-footer">
            <button class="btn btn-warning btn-sm" (click)="close()">Cancel</button>
          </div>
        }

        @if (showDeleteConfirm) {
          <div class="confirmation-modal-overlay">
            <gtw-confirmation-modal
              [config]="confirmModalConfig"
              (confirmed)="onDeleteConfirmed()"
              (cancelled)="onDeleteCancelled()"
              (closed)="onDeleteCancelled()">
            </gtw-confirmation-modal>
          </div>
        }
